var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { ref: "videoContainer", staticClass: "ratio ratio-16x9" }, [
      _vm.spinner
        ? _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-center align-items-center w-100 h-100",
              staticStyle: { "z-index": "-1" },
            },
            [_vm._m(0)]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "spinner-border", attrs: { role: "status" } },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }